import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import {
  NewsDetailsPageContainer,
  WrapContent,
  WrapBackButton,
  StyledArrowIcon,
  GoBackButton,
  RowImageText,
  ImageStart,
  WrapTagAndText,
  TitleDetails,
  ContentDetails,
  CategoryTag
} from "../../styles/NewsDetailsPage";
import { getNewsById } from "../../data/services/news";
import { NEWS } from "../../core/app-urls";
import { endpoint } from "../../utils/Constants";
import NewsModel from "../../data/model/news";

// URL fallback da imagem
const fallbackImageUrl = "URL_DA_IMAGEM_DE_FALLBACK";

// Spinner animation
const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

// Spinner wrapper
const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
`;

// Styled spinner
const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #1270B0;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const NewsDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [newsItem, setNewsItem] = useState<NewsModel | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchNewsDetails = async () => {
      if (!id) return;
      setIsLoading(true);

      try {
        const response = await getNewsById(id);
        if (response.news.length > 0) {
          setNewsItem(response.news[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar notícia", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNewsDetails();
  }, [id]);

  const handleBackButton = () => {
    navigate(NEWS);
  };

  return (
    <>
      <Header />
      <NewsDetailsPageContainer>
        <WrapContent>
          <WrapBackButton onClick={handleBackButton}>
            <StyledArrowIcon size={23} />
            <GoBackButton>Voltar para NOTÍCIAS</GoBackButton>
          </WrapBackButton>

          {isLoading ? (
            <SpinnerWrapper>
              <Spinner aria-label="Carregando conteúdo..." />
            </SpinnerWrapper>
          ) : newsItem ? (
            <RowImageText>
              <ImageStart
                src={newsItem.imagem_noticia ? `${endpoint}${newsItem.imagem_noticia}` : fallbackImageUrl}
                alt={`Imagem de ${newsItem.titulo}`}
              />

              <WrapTagAndText>
                <CategoryTag newColor={getTagColor(newsItem.tag)}>
                  {newsItem.tag}
                </CategoryTag>
                <TitleDetails>{newsItem.titulo}</TitleDetails>
                <ContentDetails dangerouslySetInnerHTML={{ __html: newsItem.descricao }} />
              </WrapTagAndText>
            </RowImageText>
          ) : (
            <TitleDetails>Notícia não encontrada</TitleDetails>
          )}
        </WrapContent>
      </NewsDetailsPageContainer>
      <Footer />
    </>
  );
};

function getTagColor(selectedCategory: string): string {
  switch (selectedCategory) {
    case "parcerias":
      return "#1270B0";
    case "eventos":
      return "#85A261";
    case "BC Saúde":
      return "pink";
    case "Reuniões":
      return "gray";
    default:
      return "";
  }
}

export default NewsDetailsPage;
